import { redirect } from 'react-router-dom';
import {
  getCard,
  getTaskCommentsEvents,
  getTaskDocuments,
  getTaskSteps,
} from '../../api-v2/queries/card-queries';
import { flowsListQuery } from '../../api-v2/queries/flows-list-query';
import { projectQuery } from '../../api-v2/queries/project-query';
import tasksListQuery from '../../api-v2/queries/tasks-list-query';
import userListQuery from '../../api-v2/queries/user-list-query';

export const myTasksPageLoader = (queryClient, user) => async (opts) => {
  const url = new URL(opts.request.url);
  const page = url.searchParams.get('page') || 1;
  const pageSize = url.searchParams.get('pageSize') || 25;
  const sort = url.searchParams.get('sort') || 'endDate:asc';
  const search = url.searchParams.get('search') || '';
  const department = url.searchParams.get('department') || '';
  const flow = url.searchParams.get('flow') || '';
  const status = url.searchParams.get('status') || '';
  const side = url.searchParams.get('side') || '';
  const projectStatus = url.searchParams.get('projectStatus') || '';
  const pipeline = url.searchParams.get('pipeline');

  const filters = {
    user: user.id,
    search,
    department,
    flow,
    status,
    side,
    projectStatus,
    pipeline,
  };

  queryClient.ensureQueryData(
    tasksListQuery({
      page,
      pageSize,
      sort,
      filters,
    }),
  );
  queryClient.ensureQueryData(flowsListQuery());

  return {
    page: parseInt(page, 10),
    pageSize: parseInt(pageSize, 10),
    user: user.id,
    sort,
    filters,
  };
};

export const queuesPageLoader = (queryClient) => async (opts) => {
  const url = new URL(opts.request.url);
  const page = url.searchParams.get('page') || 1;
  const pageSize = url.searchParams.get('pageSize') || 25;
  const sort = url.searchParams.get('sort') || 'endDate:asc';
  const search = url.searchParams.get('search') || '';
  const department = url.searchParams.get('department') || '';
  const flow = url.searchParams.get('flow') || '';
  const status = url.searchParams.get('status') || '';
  const user = url.searchParams.get('user') || '';
  const side = url.searchParams.get('side') || '';
  const projectStatus = url.searchParams.get('projectStatus') || '';
  const pipeline = url.searchParams.get('pipeline');

  const filters = { user, search, department, flow, status, side, projectStatus, pipeline };

  queryClient.ensureQueryData(tasksListQuery({ page, pageSize, filters }));
  queryClient.ensureQueryData(userListQuery());
  queryClient.ensureQueryData(flowsListQuery());

  return { page: parseInt(page, 10), pageSize: parseInt(pageSize, 10), sort, filters };
};

export const taskPageLoader = (queryClient) => async (opts) => {
  const { projectId, taskId } = opts.params;
  // TODO solve this so await is not required
  await queryClient.ensureQueryData(projectQuery({ projectId, groupView: true }));
  const card = await queryClient.ensureQueryData(getCard({ cardId: taskId }));

  if (card.projectId !== parseInt(projectId, 10)) {
    return redirect(`/projects/${card.projectId}/timeline/tasks/${card.id}`);
  }

  queryClient.ensureQueryData(flowsListQuery());
  queryClient.ensureQueryData(userListQuery({ type: 'internal' }));
  queryClient.ensureQueryData(userListQuery({ type: 'external', companyId: card.buyerCompany.id }));
  queryClient.ensureQueryData(getTaskCommentsEvents({ taskId }));
  queryClient.ensureQueryData(getTaskDocuments({ taskId }));
  queryClient.ensureQueryData(getTaskSteps({ taskId }));

  return { projectId, taskId };
};

export default myTasksPageLoader;
